module.exports = __webpack_public_path__ + "static/media/07.64f41ec8.jpg";